<div class="container">
  <div class="login-container">
    <div class="center">
      <div class="logo-container">
        <img alt="TAIS Logo" class="login-ts-logo" src="assets/TAIS-Logo5.svg" />
        <div class="centered-text">Hephaestus Login</div>
      </div>

      @if (denied) {
        <p class="warn-message">{{ errorMsg }}</p>
      }
      <br />
      <form [formGroup]="form">
        <mat-form-field appearance="fill">
          <mat-label>Benutzername</mat-label>
          <input formControlName="usr" matInput />
        </mat-form-field>
        <br />
        <mat-form-field appearance="fill">
          <mat-label>Passwort</mat-label>
          <input formControlName="pwd" matInput type="password" />
        </mat-form-field>
        <br />
        <button (click)="login()" [disabled]="form.invalid" mat-raised-button>Login</button>
      </form>
    </div>
  </div>
</div>
